import { DMCObject } from "./DMCObject";
import Konva from "konva";

const moment = require("moment");

// PUT THE TEXT IN THIS OBJECT !
export class DMCCalendar extends DMCObject {
  constructor(name, konvaObject) {
    super(name, konvaObject);

    this.locale = "fr";
    this.renderObject = null;
    this.updTimeout = null;

    if (konvaObject === undefined) {
      return;
    }

    this.field = konvaObject.field;

    this.formatDate = "LL";
    this.formatHour = "LT";

    if (konvaObject.formatDate !== undefined) this.formatDate = konvaObject.formatDate;
    if (konvaObject.formatHour !== undefined) this.formatHour = konvaObject.formatHour;

    this.targetDate = konvaObject.targetDate;
    this.noText = konvaObject.noText;
  }

  copyOption(DMCObject, creationController) {
    const newOption = super.copyOption(DMCObject, creationController);

    newOption.locale = DMCObject.locale;
    newOption.field = DMCObject.field;

    newOption.formatDate = "LL";
    newOption.formatHour = "LT";

    if (DMCObject.formatDate !== undefined) newOption.formatDate = DMCObject.formatDate;
    if (DMCObject.formatHour !== undefined) newOption.formatHour = DMCObject.formatHour;

    newOption.targetDate = DMCObject.targetDate;
    newOption.noText = DMCObject.noText;

    // Save local vars
    this.locale = DMCObject.locale;
    this.field = DMCObject.field;
    this.formatDate = newOption.formatDate;
    this.formatHour = newOption.formatHour;
    this.targetDate = DMCObject.targetDate;
    this.noText = DMCObject.noText;

    return newOption;
  }

  createNewObject(DMCObject) {
    DMCObject.konvaObjectOption.fontSize = Math.round((DMCObject.konvaObjectOption.height * 2) / 3);
    DMCObject.konvaObjectOption.fontFamily = "Roboto";
    DMCObject.konvaObjectOption.align = "center";
    DMCObject.konvaObjectOption.verticalAlign = "middle";
    DMCObject.konvaObjectOption.ellipsis = true;
    DMCObject.konvaObjectOption.formatDate = DMCObject.formatDate;
    DMCObject.konvaObjectOption.formatHour = DMCObject.formatHour;
    DMCObject.konvaObjectOption.field = DMCObject.field;
    DMCObject.konvaObjectOption.targetDate = DMCObject.targetDate;
    DMCObject.konvaObjectOption.noText = DMCObject.noText;
    DMCObject.konvaObjectOption.text = this.updateText();

    return new Konva.Text(DMCObject.konvaObjectOption);
  }

  getType() {
    return "Calendar";
  }

  load(controllerProject, DMCObject, incorporate) {
    super.load(controllerProject, DMCObject, incorporate);
    return this;
  }

  loadEnd(obj) {
    try {
      // Restore properties
      this.field = obj.field;
      this.formatDate = obj.formatDate;
      this.formatHour = obj.formatHour;
      this.noText = obj.noText;
      let properties = obj.konvaObject;

      if (typeof properties !== "object") {
        properties = JSON.parse(obj.konvaObject);
      }

      const color = properties.attrs["fill"];
      const font = properties.attrs["fontFamily"];
      // Restore properties
      this.setColor(color);
      this.setFont(font);

      // Restore target date
      this.setTargetDate(obj.targetDate);
    } catch (err) {
      console.error("Error reading calendar properties:", err);
    }
    return obj;
  }

  options() {
    return ["RectPartial", "Calendar"];
  }

  select() {
    this.konvaObject.setAttr("text", this.updateText());
  }

  updateText() {
    const target = moment(this.targetDate);
    const today = moment();

    switch (this.field) {
      case "cal-date":
        return this.strUcFirst(moment().locale(this.locale).format(this.formatDate));

      case "cal-hour":
        return this.strUcFirst(moment().locale(this.locale).format(this.formatHour));

      case "cal-weeknum":
        return moment().locale(this.locale).week();

      case "cal-count":
        if (this.noText) {
          let nbCount = target.diff(today, "days");

          if (nbCount <= 0) {
            nbCount = nbCount * -1;
          } else {
            nbCount++;
          }

          return nbCount.toString();
        } else {
          return moment(target).endOf("day").locale(this.locale).fromNow();
        }

      default:
        return "-";
    }
  }

  updateField() {
    const _this = this;

    // Get how many seconds until tomorrow
    let timeTimeout = moment().endOf("day").diff(moment(), "seconds");

    if (this.field == "cal-hour" || timeTimeout < 1) {
      timeTimeout = 30;
    }

    if (this.renderObject) {
      this.renderObject.text(this.updateText());
    }

    this.updTimeout = setTimeout(function () {
      _this.updateField();
    }, timeTimeout * 1000);
  }

  stopPreview() {
    clearTimeout(this.updTimeout);
  }

  strUcFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Setters
  setColor(val) {
    this.konvaObject.setAttr("fill", val);
    this.konvaObjectOption.fill = val;
    return val;
  }

  setFont(val) {
    this.konvaObject.setAttr("fontFamily", val);
    this.konvaObjectOption.fontFamily = val;
    return val;
  }

  setTargetDate(val) {
    this.targetDate = val;
    this.konvaObject.targetDate = val;
    this.konvaObjectOption.targetDate = val;
    return val;
  }
}
